import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, FemxProfileListing, isExchangeListing } = props;
  const images = listing.images;
  const imageVariants = ['default'];
  const thumbnailVariants = ['default'];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        FemxProfileListing={FemxProfileListing}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        isExchangeListing={isExchangeListing}
      />
    </section>
  );
};

export default SectionGallery;
